import React from "react";
import reactCSS from "reactcss";
import { SketchPicker } from "react-color";
import ReactDOM from "react-dom";

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    var hex = props.color;
    var rgb = this.hexToRgba(hex);
    const a = this.props.opacity ?? 1;
    this.state = {
      displayColorPicker: false,
      hex: props.color || "#ffffff",
      color: {
        r: rgb ? rgb.r : 255,
        g: rgb ? rgb.g : 255,
        b: rgb ? rgb.b : 255,
        a: a,
      },
    };
    this.popoverContainer = document.createElement("div");
    document.body.appendChild(this.popoverContainer);
  }

  isValidHex = (hex) => /^#([A-Fa-f0-9]{6})$/.test(hex);

  handleHexInputChange = (e) => {
    const hex = e.target.value;

    this.setState({ hex });

    if (!this.isValidHex(hex)) return;

    const rgb = this.hexToRgba(hex);

    if (!rgb) return;

    this.setState(
      {
        color: {
          r: rgb.r,
          g: rgb.g,
          b: rgb.b,
          a: this.state.color.a,
        },
      },
      () => {
        this.props.callbackFromParents({
          hex,
          a: this.state.color.a,
        });
      }
    );
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.color !== this.props.color ||
      prevProps.opacity !== this.props.opacity
    ) {
      const rgb = this.hexToRgba(this.props.color);

      if (!rgb) return;

      this.setState({
        hex: this.props.color,
        color: {
          r: rgb.r,
          g: rgb.g,
          b: rgb.b,
          a: this.props.opacity ?? 1,
        },
      });
    }
  }

  componentWillUnmount() {
    document.body.removeChild(this.popoverContainer);
  }

  componentToHex = function (c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  rgbaToHex = function ({ r, g, b, a }) {
    return (
      "#" +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b) +
      Math.round(a * 255)
        .toString(16)
        .substring(0, 2)
    );
  };

  hexToRgba = function (hex) {
    if (!hex) return null;

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    if (result) {
      return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: parseInt(result[4], 16) / 255,
      };
    }

    result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    if (result) {
      return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: 1,
      };
    }

    result = /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(hex);

    if (result) {
      return {
        r: parseInt(result[1] + result[1], 16),
        g: parseInt(result[2] + result[2], 16),
        b: parseInt(result[3] + result[3], 16),
        a: 1,
      };
    }

    return null;
  };

  // rgbaToHex = function ({ r, g, b }) {
  //   return (
  //     "#" +
  //     this.componentToHex(r) +
  //     this.componentToHex(g) +
  //     this.componentToHex(b)
  //   );
  // };

  // hexToRgba = function (hex) {
  //   const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  //   return result
  //     ? {
  //       r: parseInt(result[1], 16),
  //       g: parseInt(result[2], 16),
  //       b: parseInt(result[3], 16),
  //       a: 1,
  //     }
  //     : null;
  // };

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      displayColorPicker: !this.state.displayColorPicker,
    });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    const hex = this.rgbaToHex(color.rgb);

    this.setState(
      {
        color: color.rgb,
        hex,
      },
      () => {
        this.props.callbackFromParents({
          hex,
          a: color.rgb.a,
        });
      }
    );
  };

  renderPopover() {
    if (!this.state.displayColorPicker) return null;

    const styles = {
      popover: {
        position: "fixed",
        zIndex: 999999,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      cover: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.1)",
        zIndex: 999998,
      },
    };

    return ReactDOM.createPortal(
      <>
        <div style={styles.cover} onClick={this.handleClose} />
        <div style={styles.popover}>
          <SketchPicker
            color={this.state.color}
            onChange={this.handleChange}
            disableAlpha={false}
          />
        </div>
      </>,
      this.popoverContainer
    );
  }

  render() {
    const styles = reactCSS({
      default: {
        color: {
          width: "35px",
          height: "100%",
          minHeight: "32px",
          border: "1px solid #CCC",
          borderRadius: "4px",
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        },
        swatch: {
          background: "#fff",
          display: "inline-block",
          cursor: "pointer",
          height: "100%",
          position: "relative",
        },
      },
    });

    return (
      <>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <input
            type="text"
            value={this.state.hex}
            onChange={this.handleHexInputChange}
            style={{
              width: "100px",
              height: "32px",
              padding: "4px 6px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontFamily: "monospace",
            }}
          />

          <div style={styles.swatch} onClick={this.handleClick}>
            <div style={styles.color} />
          </div>
        </div>

        {this.renderPopover()}
      </>
    );
  }
}

export default ColorPicker;